import React from "react";
import PropTypes from "prop-types";

/**
 * TableMessage component for displaying messages in tables (error, empty, etc.)
 * @param {Object} props Component props
 * @param {string} props.message Message to display
 * @param {string} props.icon Icon class name
 * @param {string} props.type Message type (error, empty, etc.)
 * @param {number} props.colSpan Number of columns to span
 * @returns {JSX.Element} TableMessage component
 */
const TableMessage = ({ message, icon, type = "info", colSpan = 1 }) => {
  const getIconClass = () => {
    switch (type) {
      case "error":
        return icon || "bx bx-error-circle text-danger";
      case "empty":
        return icon || "bx bx-folder-open text-muted";
      case "info":
      default:
        return icon || "bx bx-info-circle text-info";
    }
  };

  return (
    <tbody>
      <tr>
        <td colSpan={colSpan} className="text-center py-5">
          <div className="d-flex flex-column align-items-center">
            <i className={`${getIconClass()} fs-1 mb-3`}></i>
            <div className="message">{message}</div>
          </div>
        </td>
      </tr>
    </tbody>
  );
};

TableMessage.propTypes = {
  message: PropTypes.string.isRequired,
  icon: PropTypes.string,
  type: PropTypes.oneOf(["error", "empty", "info"]),
  colSpan: PropTypes.number,
};

export default TableMessage;
